import React from "react";

export default function ShortAnswer() {
  return (
    <>
      <div className="w-full  h-full flex mt-2 items-center justify-center ">
        <textarea
          maxLength={36000}
          className="textarea w-full h-40  mb-10 bg-gray-300 placeholder:text-black"
          placeholder="Soruya vereceğiniz cevabı buraya yazınız"
          disabled={true}
        ></textarea>
      </div>
    </>
  );
}
